export const defaultClusterRadius = 40
